var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "justify-center": "" } },
        [_vm._t("content")],
        2
      ),
      _c(
        "v-layout",
        { attrs: { "justify-center": "" } },
        [_vm._t("message")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }